import { addMargin, introductionDesc } from "../util/vendors.js";

export default {
	init() {
		// JavaScript to be fired on all pages
		console.log('produkty');

		if (window.innerWidth > 768) {
			addMargin(introductionDesc);
		}
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};